import { useEffect, useState } from 'react'

import { interWbSession, IWbUserInfo } from '@interco/inter-webview-bridge'

type TUseGetUserInfo = {
  isLoading: boolean
  isError: boolean
  info?: IWbUserInfo
}

const useGetUserInfo = (): TUseGetUserInfo => {
  const [userInfo, setUserInfo] = useState<TUseGetUserInfo>({
    isError: false,
    isLoading: false,
  })

  useEffect(() => {
    setUserInfo((current) => ({ ...current, isLoading: true }))

    const getUserInfoCallback = async () => {
      try {
        const info = await interWbSession.getUserInfo()

        setUserInfo((current) => ({ ...current, info }))
      } catch {
        setUserInfo((current) => ({ ...current, isError: true }))
      } finally {
        setUserInfo((current) => ({ ...current, isLoading: false }))
      }
    }

    getUserInfoCallback()
  }, [setUserInfo])

  return userInfo
}

export { useGetUserInfo }
